import { render, staticRenderFns } from "./InsectCountDifference.vue?vue&type=template&id=a94bf6e8&scoped=true&"
import script from "./InsectCountDifference.vue?vue&type=script&lang=js&"
export * from "./InsectCountDifference.vue?vue&type=script&lang=js&"
import style0 from "./InsectCountDifference.vue?vue&type=style&index=0&id=a94bf6e8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94bf6e8",
  null
  
)

/* custom blocks */
import block0 from "./InsectCountDifference.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a94bf6e8')) {
      api.createRecord('a94bf6e8', component.options)
    } else {
      api.reload('a94bf6e8', component.options)
    }
    module.hot.accept("./InsectCountDifference.vue?vue&type=template&id=a94bf6e8&scoped=true&", function () {
      api.rerender('a94bf6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GalleryView/InsectCountDifference.vue"
export default component.exports